var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('strong',{staticClass:"text-black text-bold text-2xl"},[_vm._v("Dashboard Affiliate")]),_c('Cards'),_c('List')],1)}
var staticRenderFns = []

export { render, staticRenderFns }